export type IllustrationSize = 80 | 120 | 142;

export type IllustrationName =
  | 'success'
  | 'error'
  | 'upgrade'
  | 'downgrade'
  | 'mail'
  | 'warningYellow'
  | 'updateBlue'
  | 'skull'
  | 'sandboxConnect'
  | 'logout'
  | 'heartbreak'
  | 'time'
  | 'search'
  | 'credentialPrimary'
  | 'credentialSecondary'
  | 'credentialTertiary';

export type IllustrationProps = {
  id?: string;
  className?: string;
  imgName: IllustrationName;
  size?: IllustrationSize;
  containerStyle?: any;
};

export type SingleIllustrationProps = {
  id?: string;
  className?: string;
  size?: IllustrationSize;
  containerStyle?: any;
};

import SuccessImg from '../../../foundations/Illustrations/images/success.png';
import ErrorImg from '../../../foundations/Illustrations/images/error.png';
import UpgradeImg from '../../../foundations/Illustrations/images/upgrade.png';
import DowngradeImg from '../../../foundations/Illustrations/images/downgrade.png';
import MailImg from '../../../foundations/Illustrations/images/mail.png';
import WarningYellowImg from '../../../foundations/Illustrations/images/warningYellow.png';
import UpdateBlueImg from '../../../foundations/Illustrations/images/updateBlue.png';
import TrashImg from '../../../foundations/Illustrations/images/trash.png';
import TrashLightGreyImg from '../../../foundations/Illustrations/images/trashLigthGrey.png';
import QuestionMarkImg from '../../../foundations/Illustrations/images/questionMark.png';
import WarningRedImg from '../../../foundations/Illustrations/images/warningRed.png';
import SkullImg from '../../../foundations/Illustrations/images/skull.png';
import SandboxConnectImg from '../../../foundations/Illustrations/images/sandboxConnect.png';
import LogoutImg from '../../../foundations/Illustrations/images/logout.png';
import HeartbreakImg from '../../../foundations/Illustrations/images/heartbreak.png';
import TimeImg from '../../../foundations/Illustrations/images/time.png';
import SearchImg from '../../../foundations/Illustrations/images/search.png';
import CredentialPrimaryImg from '../../../foundations/Illustrations/images/credentialPrimary.png';
import CredentialSecondaryImg from '../../../foundations/Illustrations/images/credentialSecondary.png';
import CredentialTertiaryImg from '../../../foundations/Illustrations/images/credentialTertiary.png';

export const IllustrationsMap = {
  success: SuccessImg,
  error: ErrorImg,
  upgrade: UpgradeImg,
  downgrade: DowngradeImg,
  mail: MailImg,
  warningYellow: WarningYellowImg,
  updateBlue: UpdateBlueImg,
  trash: TrashImg,
  questionMark: QuestionMarkImg,
  trashLightGrey: TrashLightGreyImg,
  warningRed: WarningRedImg,
  skull: SkullImg,
  sandboxConnect: SandboxConnectImg,
  logout: LogoutImg,
  heartbreak: HeartbreakImg,
  time: TimeImg,
  search: SearchImg,
  credentialPrimary: CredentialPrimaryImg,
  credentialSecondary: CredentialSecondaryImg,
  credentialTertiary: CredentialTertiaryImg,
};

export const stateIllustrations = [
  'success',
  'error',
  'upgrade',
  'downgrade',
  'mail',
  'warningYellow',
  'updateBlue',
  'trash',
  'questionMark',
  'trashLightGrey',
  'warningRed',
  'skull',
  'sandboxConnect',
  'logout',
  'heartbreak',
  'time',
  'search',
];

export const credentialIllustrations = [
  'credentialPrimary',
  'credentialSecondary',
  'credentialTertiary',
];
